import React, { Component } from 'react'
import { Button, Col, Row } from 'reactstrap'
import { observer } from 'mobx-react'
import Card from '../../../comum/components/Card'
import FormInputSimples from '../../../comum/components/FormInputSimples'
import FormSelectSimples from '../../../comum/components/FormSelectSimples'
import { FecharFiltro, Filtro } from '../../../comum/components/Icones'

@observer
export default class FiltroConsulta extends Component {

    constructor(props) {

        super(props)

        this.controller = this.props.controller

        this.state = {
            mostrarFiltros: false
        }

        this.clickMaisFiltros  = this.clickMaisFiltros.bind(this)
    }

    clickMaisFiltros() {
        this.setState({
            mostrarFiltros: !this.state.mostrarFiltros
        })
    }

    render() {
        return (
            <div className="filtro-card filtros-cabotagem">
                <Card className={`area-form pb-0`}>
                    <Row className="pb-0">
                        <FormInputSimples
                            xs={12} sm={12} md={6} lg={4} xl={2}
                            titulo="Documento (BL / DUe)"
                            onEnter={this.controller.listar}
                            dado={this.controller.bl}
                            onChange={(event) => this.controller.setBl(event.target.value)}
                        />
                        {
                            this.state.mostrarFiltros &&
                            <React.Fragment>
                                <FormInputSimples
                                    xs={12} sm={12} md={6} lg={4} xl={2}
                                    titulo="Container"
                                    onEnter={this.controller.listar}
                                    dado={this.controller.container}
                                    onChange={(event) => this.controller.setContainer(event.target.value)}
                                />
                                <FormInputSimples
                                    xs={12} sm={12} md={6} lg={4} xl={2}
                                    titulo="Cliente"
                                    onEnter={this.controller.listar}
                                    dado={this.controller.cliente}
                                    onChange={(event) => this.controller.setCliente(event.target.value)}
                                />
                                <FormInputSimples
                                    xs={12} sm={12} md={6} lg={4} xl={2}
                                    titulo="Orçamento / Nota"
                                    onEnter={this.controller.listar}
                                    dado={this.controller.nota}
                                    onChange={(event) => this.controller.setNota(event.target.value)}
                                />
                                <FormSelectSimples
                                    xs={12} sm={12} md={6} lg={4} xl={2}
                                    titulo="Situação"
                                    dado={this.controller.situacaoSelecionada}
                                    itens={this.controller.situacoes}
                                    onChange={this.controller.setSituacao}
                                />
                                <FormSelectSimples
                                    xs={12} sm={12} md={6} lg={4} xl={2}
                                    titulo="Tipo"
                                    dado={this.controller.tipoSelecionado}
                                    itens={this.controller.tipos}
                                    onChange={this.controller.setTipo}
                                />
                            </React.Fragment>
                        }
                        <Col className="col-botoes">
                            <Button className={`btn-filtros ${this.state.mostrarFiltros && 'ativo'}`} onClick={ this.clickMaisFiltros } outline >
                                { this.state.mostrarFiltros ?
                                    <div><FecharFiltro color="#93A0AD" className="mr-2" width="15" height="15"/>Menos filtros</div>
                                    :
                                    <div><Filtro color="#93A0AD" className="mr-2" width="15" height="15"/>Mais filtros</div>
                                }
                            </Button>
                            <Button className="btn-com-bordas-primary btn-filtrar" onClick={this.controller.listar}>
                                Filtrar
                            </Button>
                        </Col>
                    </Row>
                </Card>
            </div>
        )
    }
}

/**
 * Filtros:
 *  - Número do BL: Select ou input?
 *  Código do container: Input
 *  Cliente: Input
 *  Nota: Input
 *  Situação: Select
 *  Tipo: Select
 */


// WEBPACK FOOTER //
// ./src/modules/faturamento/consulta/components/FiltroConsulta.js